import React from 'react'
import MaterialSymbol from '../material-symbol'

const RemoveCircle = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="remove_circle" {...props} />
))

RemoveCircle.displayName = 'RemoveCircle'

export default RemoveCircle
